'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _validationConstants = require('../../validationConstants');

var _fieldValidationService = require('../../fieldValidationService');

var _fieldValidationService2 = _interopRequireDefault(_fieldValidationService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OBJECT_ERROR_OBJECT = {
    name: _validationConstants.FAILURE_NAMES.object,
    type: _validationConstants.FAILURE_TYPES.ERROR,
    message: 'Must be a plain object'
};

exports.default = function (fieldValue, validationConfig) {
    if (!fieldValue) return;

    if (!(0, _lodash.isPlainObject)(fieldValue)) {
        return _extends({}, OBJECT_ERROR_OBJECT, {
            details: fieldValue
        });
    }

    if (validationConfig.keys) {
        var fieldErrors = validationConfig.keys.map(function (keyType) {
            return (0, _fieldValidationService2.default)(fieldValue[keyType.name], keyType);
        }).filter(function (err) {
            return !!err;
        });

        if (fieldErrors.length) {
            return _extends({}, OBJECT_ERROR_OBJECT, {
                message: 'Object key validation failed',
                details: fieldErrors
            });
        }
    }

    return null;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/type/objectValidator.js
// module id = 2307
// module chunks = 0